<template>
  <div class="d-admin-exit-modal">
    <DExitModal
      data-disable-period-type="weeks"
      data-disable-period-value="1"
      data-show-at-position="100"
      :data-modal-campaign-name="campaignName"
      :data-modal-description="description"
      :data-modal-header="header"
      :data-modal-id="modalId"
      :data-modal-image="image"
      data-modal-key="blog-signup-modal"
      :data-modal-name="name"
      data-modal-tags="discovery"
      :data-modal-test="test"
      :data-modal-test-start-date="testStartDate"
      data-show-on-scroll-direction="up"
      id="exit-modal"
    >
      <template #modal-image>
        <img :src="contentImage">
      </template>

      <template #modal-body>
        <h2>
          {{ header }}
        </h2>

        <p class="space-bottom-2em">
          {{ description }}
        </p>

        <slot name="cta" />

        <form
          v-if="!$slots.cta"
          id="blog-signup-form"
          :action="formSubmitUrl"
          method="POST"
          @submit="trackEvent($event)"
        >
          <input
            hidden
            name="blog"
            :value="formFields.blog"
          >

          <input
            hidden
            name="modal"
            value="true"
          >

          <input
            hidden
            name="interest"
            :value="formFields.interest"
          >

          <input
            hidden
            name="campaign_name"
            :value="formFields.campaign_name"
          >

          <div class="modal-signup">
            <div class="input-container">
              <input
                class="input-full"
                name="email"
                placeholder="Enter your email address..."
                required
                type="email"
              >
            </div>
            <div class="button-container">
              <button class="button-black">
                Sign up
              </button>
            </div>
          </div>

          <DFormRecaptcha
            action-name="discovery_signup_blog_exit_modal"
            form-id="blog-signup-form"
            :recaptcha-v3-key="recaptchaKey"
          />
        </form>

        <div class="grid-2 grid-gutters-lg space-top-1em grid-no-response">
          <div class="grid-item">
            <DSignupButton
              class="button-sm button-full"
              text="Sign up with"
              type="facebook"
              :tracking-extra="getTrackingExtra('facebook')"
              :tracking-modals="trackingModalsParams"
              :url="getSocialSignUpUrl('facebook')"
            />
          </div>
          <div class="grid-item">
            <DSignupButton
              class="button-sm button-full button-white-bordered"
              text="Sign up with"
              type="google"
              :tracking-extra="getTrackingExtra('google')"
              :tracking-modals="trackingModalsParams"
              :url="getSocialSignUpUrl('google')"
            />
          </div>
        </div>
      </template>
    </DExitModal>

    <DModalMobileAlert
      :content="mobileCta"
      :image-url="contentImage"
      modal-id="exit-modal"
      :show-at-position="'100'"
      :show-only-on-scroll-up="true"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import URLS from '@d-shared/urls/urls';
import DFormRecaptcha from '../../../../public-app/components/d-form-recaptcha/d-form-recaptcha.vue';
import DModalMobileAlert from '@d-shared/components/exit-modals/d-modal-mobile-alert/d-modal-mobile-alert.vue';
import DSignupButton from '@d-shared/components/d-signup-button/d-signup-button.vue';
import DExitModal from '@d-shared/components/exit-modals/d-exit-modal/d-exit-modal.vue';

export default {
  components: {
    DFormRecaptcha,
    DExitModal,
    DModalMobileAlert,
    DSignupButton,
  },
  props: {
    description: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    test: {
      type: String,
      required: true,
    },
    testStartDate: {
      type: String,
      required: true,
    },
    campaignName: {
      type: String,
      required: true,
    },
    modalId: {
      type: String,
      required: true,
    },
    contentImage: {
      type: String,
      required: true,
    },
    formFields: {
      type: Object,
      required: true,
    },
    recaptchaKey: {
      type: String,
      required: true,
    },
    blogId: {
      type: String,
      required: true,
    },
    mobileCta: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    formSubmitUrl: URLS.app.signUp.regular,
    trackingModalsParams: { modalId: 'exit-modal', eventName: 'submit' },
  }),
  methods: {
    trackEvent(event) {
      Vue.prototype.trackingHandler.trackEvent('exit-modal', 'submit');
      Vue.prototype.eventsTracking.trackAndSubmitForm(
        'sign-up-request',
        {
          type: 'form',
          location: 'blog-signup-form',
          method: 'email',
        },
        event.target,
      );
    },
    getSocialSignUpUrl(type) {
      let url = `${URLS.app.signUp[type]}?modal=true`;

      if (this.formFields.blog) {
        url += `&blog=${this.formFields.blog}`;
      }

      if (this.formFields.interest) {
        url += `&interest=${this.formFields.interest}`;
      }

      return url;
    },
    getTrackingExtra(method) {
      return {
        blog_id: this.blogId,
        type: 'button',
        location: 'exit-modal',
        method,
      };
    },
  },
};
</script>
